import React from "react";
import CarouselV2 from "../../componentes/carousel/CarouselV2";

const CardCatalogo = ({
    producto,
    onVerDetallesClick,
    onAgregarClick,
    onCotizarClick,
    textoBotonAgregar = "Carrito",
    ocultarBoton = false,
}) => {

    const {
        id,
        imagenes = [],
        nombre,
        descripcion,
        precio,
        precioOriginal,
        tienePromocion,
        descuentoPorcentaje,
    } = producto;

    return (
        <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
            <div className="card h-100 shadow-sm border-0 rounded-lg">
                <div className="position-relative card-img-container d-flex justify-content-center align-items-center overflow-hidden bg-light" style={{ height: "320px" }}>
                    {tienePromocion && descuentoPorcentaje && (
                        <span
                            className="badge bg-danger position-absolute px-3 py-2 rounded-pill"
                            style={{ top: "10px", left: "10px", fontSize: "0.95rem", zIndex: 2 }}
                        >
                            -{descuentoPorcentaje}
                        </span>
                    )}
                    {imagenes.length > 0 ? (
                        <CarouselV2
                            id={`carouselProducto${id}`}
                            datos={imagenes.map(url => ({ url, nombre }))}
                        />
                    ) : (
                        <img
                            src="/productos.jpg"
                            className="card-img-top img-fluid p-3"
                            alt={nombre}
                            style={{
                                objectFit: "contain",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    )}
                </div>

                <div className="card-body d-flex flex-column p-3">
                    <h5 className="card-title text-truncate mb-2" title={nombre}>{nombre}</h5>
                    <p className="card-text text-muted small">{descripcion || "Sin descripción"}</p>

                    {tienePromocion && precioOriginal ? (
                        <div className="mb-2">
                            <div className="d-flex align-items-baseline">
                                <small
                                    className="text-muted me-2"
                                    style={{ textDecoration: "line-through", fontSize: "0.9rem" }}
                                >
                                    L {precioOriginal}
                                </small>
                                <span className="badge bg-danger mx-1 p-1 rounded-pill">
                                    -{descuentoPorcentaje}
                                </span>
                            </div>
                            <div>
                                <span className="text-success fw-bold fs-4">
                                    L {precio}
                                </span>
                            </div>
                        </div>
                    ) : (
                        <p className="card-text fw-bold mb-2 fs-4">
                            L {precio}
                        </p>
                    )}

                    <p className="card-text text-muted mt-auto" style={{ fontSize: "0.75rem" }}>
                        * ISV Incluido
                    </p>
                </div>

                {!ocultarBoton && (
                    <div className="card-footer border-0 pt-0 pb-3 px-3 text-center">
                        <div className="d-grid gap-2">
                            <button
                                onClick={() => onVerDetallesClick(producto)}
                                className="btn btn-outline-primary fw-bold rounded-pill py-2 w-100"
                            >
                                <i className="fas fa-eye me-1 mx-2"></i>
                                Ver más
                            </button>
                            <button
                                onClick={() => onAgregarClick(producto)}
                                className="btn btn-dark text-white fw-bold rounded-pill py-2 w-100 my-2"
                            >
                                <i className="fas fa-cart-plus me-1 mx-2"></i>
                                {textoBotonAgregar}
                            </button>
                            {onCotizarClick && (
                                <button
                                    onClick={() => onCotizarClick(producto)}
                                    className="btn btn-primary fw-bold rounded-pill py-2 w-100"
                                >
                                    <i className="fas fa-file-invoice me-1 mx-2"></i>
                                    Cotizar
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardCatalogo;
